<script setup lang="ts">
  import { shallowRef, computed, onBeforeMount } from "vue";

  import { useRolesStore } from "@/stores/roles";

  import mjimage from "./mjimage.vue";
  import mjgif from "./mjgif.vue";
  import mjdivider from "./mjdivider.vue";
  import mjbutton from "./mjbutton.vue";
  import mjspacer from "./mjspacer.vue";
  import mjtext from "./mjtext.vue";
  import mjraw from "./mjraw.vue";
  import mjsocial from "./mjsocial.vue";
  import mjdynamic from "./mjdynamic.vue";
  import mjcarousel from "./mjcarousel.vue";
  import mjapiblock from "./mjapiblock.vue";
  import mjloop from "./mjloop.vue";
  import mjrating from "./mjrating.vue";
  import LockedOverylay from "./lockedOverylay.vue";
  import { useMjmlStore } from "@/stores/mjmlStore";

  const rolesStores = useRolesStore();

  const props = defineProps([
    "block",
    "columnIndex",
    "sectionIndex",
    "blockIndex",
  ]);

  const blockName = shallowRef();
  const mjmlStore = useMjmlStore();

  const isLocked = computed(() => {
    return props.block.locked && props.block.locked
      ? props.block.locked
      : false;
  });

  const getComponent = () => {
    if (!props.block.tagName) return;

    const name = props.block.tagName.replaceAll("-", "");

    if (name === "mjimage") {
      return mjimage;
    }
    if (name === "mjgif") {
      return mjgif;
    }
    if (name === "mjbutton") {
      return mjbutton;
    }
    if (name === "mjspacer") {
      return mjspacer;
    }
    if (name === "mjtext") {
      return mjtext;
    }
    if (name === "mjraw") {
      return mjraw;
    }
    if (name === "mjsocial") {
      return mjsocial;
    }
    if (name === "mjdivider") {
      return mjdivider;
    }
    if (name === "mjproduct") {
      return mjapiblock;
    }
    if (name === "mjdynamic") {
      return mjdynamic;
    }
    if (name === "mjcarousel") {
      return mjcarousel;
    }
    if (name === "mjarticle") {
      return mjapiblock;
    }
    if ("mjfeedblock" === name) {
      return mjapiblock;
    }
    if ("mjloop" === name) {
      return mjloop;
    }
    if (name === "mjrating") {
      return mjrating;
    }
  };

  const onLockedLayoutClicked = () => {
    mjmlStore.selectBlock({
      sectionIndex: props.sectionIndex,
      columnIndex: props.columnIndex,
      blockIndex: props.blockIndex,
    });
  };

  onBeforeMount(() => {
    blockName.value = getComponent();
  });
</script>

<template>
  <component
    :is="blockName"
    v-if="!isLocked || rolesStores.permissions.canEditLockedBlocks"
    :block="block"
    :column-index="columnIndex"
    :section-index="sectionIndex"
    :block-index="blockIndex"
    :is-locked="isLocked"
    :data-testid="block.tagName"
  ></component>

  <LockedOverylay
    v-else
    :block="block"
    :column-index="columnIndex"
    :section-index="sectionIndex"
    @click="onLockedLayoutClicked"
  >
    <component
      :is="blockName"
      :block="block"
      :column-index="columnIndex"
      :section-index="sectionIndex"
      :block-index="blockIndex"
      :is-locked="isLocked"
      :data-testid="block.tagName"
      class="locked-block"
    ></component>
  </LockedOverylay>
</template>
